export default __webpack_public_path__ + "static/media/studio 8.7ee50998.png";